import React from 'react';

// eslint-disable-next-line react/prop-types
const Footer = ({ link }) => (
  <div className="u-pb-30 u-mt-4 u-text-small u-co-grey--light u-ta-center shared-footer">
    To manage notifications&nbsp;
    <a className="u-co-grey--light u-td-underline u-co-black-2" href={link} target="_blank">
      click here
    </a>
    .
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/Flagship/components/Footer.jsx